import React, { useEffect, useState } from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import ReusableRightDrawer from "./ReusableRightDrawer";
import PopupMultiSelectField from "./PopupMultiSelectField";
import usePageFilterOptions from "../hooks/usePageFilterOptions";

export default function ContactFiltersDrawer({ open, value, onClose, onApply }) {
  const [draft, setDraft] = useState(value || {});
  useEffect(() => { if (open) setDraft(value || {}); }, [open, value]);
  const directory = usePageFilterOptions(open, "/api/contacts", draft, setDraft);
  return <ReusableRightDrawer open={open} onClose={onClose} headerLeft={<Typography fontWeight={700}>Filter contacts</Typography>}
    footer={<Stack direction="row" spacing={1} sx={{ p: 2 }}>
      <Button onClick={() => { setDraft({ companyNames: [], activities: [] }); onApply({ companyNames: [], activities: [] }); }}>Clear Filters</Button>
      <Button variant="contained" onClick={() => { onApply(draft); onClose(); }}>Apply Filters</Button>
    </Stack>}>
    <Stack spacing={2} sx={{ p: 2 }}>
      {directory.error && <Alert severity="error">{directory.error}</Alert>}
      {directory.loading && <Typography role="status">Loading filter values...</Typography>}
      {[['companyNames', 'Company Name', 'Type company name'], ['activities', 'Activity', 'Select one or more activities']].map(([field, label, placeholder]) =>
        <React.Fragment key={field}><Typography>{label}:</Typography><PopupMultiSelectField
          freeSolo={false} options={directory.options[field] || []} {...directory.fieldProps(field)}
          value={draft[field] || []} placeholder={placeholder}
          onChange={next => setDraft(previous => ({ ...previous, [field]: next }))} /></React.Fragment>)}
    </Stack>
  </ReusableRightDrawer>;
}
